<div class="loading" *ngIf="isVisible$ | async as isVisible" [hidden]="!isVisible">
    <span>{{ fallbackMessage }}</span>
</div>
